import InnerComponent from '@Components/Production/Configurations';
import orgContainer from '@Components/AppContainer';

const Configurations = () => ((orgContainer(InnerComponent)));
export default Configurations;
